import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

class VideoSlider {
  constructor(props) {
    this.container = props.container;
    this.sliderPlaying =
      $('.video-slider__player .plyr__video-embed', this.container) ||
      $('.video-slider__player .plyr-video', this.container);
    this.sliderPlayingTitle = $('.video__title', this.container);
    this.videoButtons = $$('.video-slider__button', this.container);
    this.sliderItems = $$('.video-slider__item', this.container);
  }

  setFirstSliderItemPlaying = () => {
    this.sliderItems[0].classList.add('is-playing');
  };

  changeSourceAndTitle = button => {
    this.sliderItems.forEach(item => {
      item.classList.remove('is-playing');
    });

    const sliderItem = button.closest('.video-slider__item');
    sliderItem.classList.add('is-playing');

    const itemUrl = sliderItem.getAttribute('data-videourl');
    const itemType = sliderItem.getAttribute('data-type');

    if (itemType === 'video/mp4') {
      this.sliderPlaying.plyr.source = {
        type: 'video',
        sources: [
          {
            src: itemUrl,
            type: itemType,
          },
        ],
        poster: $('video', sliderItem).getAttribute('poster') || null,
      };
    } else {
      this.sliderPlaying.plyr.source = {
        type: 'video',
        sources: [
          {
            src: itemUrl,
            provider: itemType,
          },
        ],
      };
    }

    this.sliderPlayingTitle.innerHTML =
      sliderItem.getAttribute('data-videoTitle');
    $('.video-slider__inner').setAttribute('data-type', itemType);
  };

  bindEvents = () => {
    this.videoButtons.forEach(button => {
      button.addEventListener(
        'click',
        this.changeSourceAndTitle.bind(this, button)
      );
    });
  };

  init = () => {
    this.bindEvents();
    this.setFirstSliderItemPlaying();
  };
}

const videoSliders = $$('.video-slider');

if (videoSliders.length) {
  videoSliders.forEach(videoSlider => {
    const slider = new Swiperslider(
      $('.video-slider__item-wrapper', videoSlider),
      {
        container: videoSlider,
        sliderOptions: {
          spaceBetween: 15,
          lazy: false,
          breakpoints: {
            // when window width is >= 768px
            768: {
              spaceBetween: 30,
            },
          },
        },
      }
    );
    slider.init();
  });

  videoSliders.forEach(videoSlider => {
    new VideoSlider({
      container: videoSlider,
    }).init();
  });
}
